/**
*
* Checkbox
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import CheckboxWrapper from './styles/CheckboxWrapper';
import CheckboxInput from './styles/CheckboxInput';
import CheckboxCheckmark from './styles/CheckboxCheckmark';
import CheckboxLabel from './styles/CheckboxLabel';

class Checkbox extends React.PureComponent {
  constructor() {
    super();

    this.handleCheckbox = this.handleCheckbox.bind(this);

  }

  handleCheckbox(event) {
    this.props.sendDataCallback(event)
  }

  render() {

    const { 
      label, 
      value, 
      checked
    } = this.props;

    return (
      <CheckboxWrapper>
        <CheckboxLabel>
          <CheckboxInput 
            value={value}
            type="checkbox"
            checked={checked}
            onChange={this.handleCheckbox}
          />
          <CheckboxCheckmark>{label ? label : ''}</CheckboxCheckmark>
        </CheckboxLabel>
      </CheckboxWrapper>
    )
  }
};

Checkbox.propTypes = {
  title: PropTypes.string
};

export default Checkbox;
